import { TourId, useTourContext } from '@/contexts/TourContext';
import { AnnualReportTour } from '@/pages/AnnualReportDetailsNew/AnnualReportTour/AnnualReportTour';

export function TourManager() {
  const { activeTourId } = useTourContext();

  if (!activeTourId) return null;

  switch (activeTourId) {
    case TourId.ANNUAL_REPORT:
      return <AnnualReportTour />;

    default:
      return null;
  }
}
